module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e6466e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAdmin/AccountAdminMainFooter.vue
// module id = 1464
// module chunks = 7